import React, { createContext, useCallback, useState, useContext } from 'react';

const AmbientContext = createContext({});

const AmbientProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const type = JSON.parse(localStorage.getItem('@BusCAR:ambient'));

    if (type) {
      return type
    }

    return { type: 'default', admin: false, pessoa_juridica_id: null, pessoa_juridica_id_master: null };
  });

  const setAmbient = useCallback(({ type, admin, pessoa_juridica_id, pessoa_juridica_id_master }) => {
    localStorage.setItem('@BusCAR:ambient', JSON.stringify({ 
      type, 
      admin, 
      pessoa_juridica_id,
      pessoa_juridica_id_master 
    }));

    setData({
      type, 
      admin, 
      pessoa_juridica_id,
      pessoa_juridica_id_master
    })
  }, []);

  const isEnterpriseEnv = data.type === 'empresarial';
  
  return (
    <AmbientContext.Provider
      value={{ ambient: data, setAmbient, isEnterpriseEnv }}
    >
      {children}
    </AmbientContext.Provider>
  )
}

function useAmbient() {
  const context = useContext(AmbientContext);

  if (!context) {
    throw new Error('useAmbient must be used within a AmbientProvider');
  }

  return context;
}

export { AmbientProvider, useAmbient };